<router-outlet *ngIf="isLogin"></router-outlet>
<app-loader *ngIf="!isLogin" [loading]="!isLogin" ></app-loader>
